import { render, staticRenderFns } from "./CSelectFrame.vue?vue&type=template&id=63648c14&"
import script from "./CSelectFrame.vue?vue&type=script&lang=ts&"
export * from "./CSelectFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports